import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { graphBeeswarmLayout } from './force';
import { staticLayout } from './static';
import { absoluteLayout } from './absolute';

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerLayout(graphBeeswarmLayout);
  registers.registerLayout(staticLayout);
  registers.registerLayout(absoluteLayout);
}
